let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hlJc4")).then(() => parcelRequire('Xa5VS'));